import type { XingletInterface } from '../../jobs-xinglet';
import { JobsXingletWrapper } from '../../jobs-xinglet';

export type SearchAlertsErrorBannerXinglet = XingletInterface;

export const SearchAlertsErrorBanner = JobsXingletWrapper(
  '@xing-com/crate-jobs-domain-search-alerts-error-banner'
);
